<template>
  <transition
    appear
    name="ten-fade-in"
    @after-leave="onAfterClose"
  >
    <div
      v-if="showMessage"
      :class="className"
      @mouseenter="clearTimer"
      @mouseleave="startTimer"
    >
      <ten-icon
        class="ten-message__icon"
        :icon="iconType"
      />
      <div class="ten-message__content">
        <render-cell
          v-if="typeof content === 'function'"
          :render="content"
        />
        <template v-else>
          {{ content }}
        </template>
      </div>
      <ten-icon
        v-if="showClose"
        class="ten-message__icon ten-message__close"
        icon="clear"
        @click="close"
      />
    </div>
  </transition>
</template>

<script>
import TenIcon from '../icon';
import RenderCell from '../render-cell';

const name = 'ten-message';

const ICON_TYPE_MAP = {
  error: 'circle_clear',
  success: 'circle_tick',
  warning: 'circle_error',
  info: 'circle_info',
};

export default {
  name,
  components: {
    TenIcon,
    RenderCell,
  },
  props: {
    /**
     * 暗色模式
     */
    dark: Boolean,
    /**
     * 消息类型
     *
     * @member success | info | warning | error
     */
    type: { type: String, validator(v) {
      return ['success', 'info', 'warning', 'error'].indexOf(v) > -1;
    } },
    /**
     * 消息内容
     */
    content: [String, Function],
    /**
     * 显示关闭按钮
     */
    showClose: Boolean,
    /**
     * 显示时长，单位ms
     */
    duration: { type: Number, default: 3000 },
    /**
     * 消息消失的回调函数
     */
    onClose: Function,
    /**
     * 自定义icon
     */
    icon: String,
    /**
     * 自定义类名
     */
    customClass: String,
    /**
     * Message 距离窗口顶部的偏移量
     */
    offset: {
      type: Number,
      default: 14,
    },
    /**
     * @ignore
     */
    onAfterClose: Function,
  },
  data() {
    return {
      showMessage: true,
    };
  },
  computed: {
    className() {
      return [
        'ten-message',
        this.customClass,
        {
          'ten-message--dark': this.dark,
          'ten-message--success': this.type === 'success',
          'ten-message--error': this.type === 'error',
          'ten-message--info': this.type === 'info',
          'ten-message--warning': this.type === 'warning',
          'ten-message--closable': this.showClose,
        },
      ];
    },
    iconType() {
      return this.icon || ICON_TYPE_MAP[this.type];
    },
  },
  created() {
    this.time = null;
  },
  mounted() {
    this.startTimer();
  },
  methods: {
    close() {
      this.showMessage = false;
      this.onClose && this.onClose();
    },
    clearTimer() {
      clearTimeout(this.timer);
    },
    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (this.showMessage) {
            this.clearTimer();
            this.close();
          }
        }, this.duration);
      }
    },
  },
};
</script>
